import React from "react";
import "./Boss.scss";
import SimpleSlider from "./components/SimpleSlider";
import HtmlView from "component/htmlView/html-view";
// import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { FormattedMessage } from "react-intl";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from "react-redux";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import ReactGA from "react-ga4";

function Boss() {
  const currentLocale = useSelector(({ theme }) => theme.locale);

      
  ReactGA.initialize(END_POINTS.TRACKING_ID);
  
  React.useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/about/chairman-word", title: "About Boss Page" });
  }, []);
  

  const bossList = useSWR({
    url: END_POINTS.CAPMAS_HEAD,
  });

  const [currentBoss, setCurrentBoss] = React.useState([]);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      setCurrentBoss(bossList?.data?.data.find((el) => el.isCurrent === true));
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [bossList]);

  const oldBoss = [
    {
      personalName: "اللواء / أبو بكر الجندي",
      personalImg: process.env.PUBLIC_URL + "/image/bo1.png",
      date: "2005 - 2018",
    },
    {
      personalName: "اللواء / إيهاب علوي",
      personalImg: process.env.PUBLIC_URL + "/image/bo2.png",
      date: "1995 - 2005",
    },
    {
      personalName: "اللواء د.م / فاروق عبد العظيم",
      personalImg: process.env.PUBLIC_URL + "/image/bo3.png",
      date: "1991 - 1995",
    },
    {
      personalName: "اللواء د.م / مختار هلودة",
      personalImg: process.env.PUBLIC_URL + "/image/bo4.png",
      date: "1981 - 1991",
    },
    {
      personalName: "الفريق / جمال الدين عسكر",
      personalImg: process.env.PUBLIC_URL + "/image/bo5.png",
      date: "1961 - 1981",
    },
  ];

  return (
    <ContentLoading isLoading={bossList.isLoading}>
      <div className="Boss">
        {currentBoss?.isCurrent ? (
          <div className="boss-container">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-3">
                  <div className="img-boos">
                    <img
                      src={
                        currentBoss && currentBoss?.imageUrl
                          ? currentBoss.imageUrl
                          : process.env.PUBLIC_URL + "/image/boss.png"
                      }
                      className="img-fluid"
                      alt="boos"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-9">
                  <div className="boss-title">
                    <h2>
                      <LabelLang
                        id={"name"}
                        defaultValue={currentBoss?.name}
                        translations={currentBoss?.capmasHeadTranslations}
                      />
                    </h2>
                    <p>
                      <FormattedMessage id="president-description" />
                    </p>
                    <p>
                      <FormattedMessage id="republic" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          {currentBoss?.isCurrent ? (
            <div className="row mb-3">
              <div className="col-12 col-lg-3">
                <div className="boss-bg">
                  {/* <img 
                    src={process.env.PUBLIC_URL + "/image/Asset 2.svg"}
                    style={{width: '300px'}}
                    alt="boos"
                    loading="lazy"
                  /> */}
                </div>
              </div>
              <div className="col-12 col-lg-9">
                <div className="boss-words">
                  {currentBoss?.statement !== null &&
                  currentBoss?.statement !== undefined ? (
                    <HtmlView
                      html={LabelLangString({
                        id: "statement",
                        currentLocale: currentLocale,
                        defaultValue: currentBoss?.statement,
                        translations: currentBoss?.capmasHeadTranslations,
                      })}
                    />
                  ) : (
                    <FormattedMessage id="data-not-found" />
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-9"></div>
              <div className="col-12 col-lg-3">
                <div className="sin">
                  <p>
                    <LabelLang
                      id={"name"}
                      defaultValue={currentBoss?.name}
                      translations={currentBoss?.capmasHeadTranslations}
                    />
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <DataNotFound />
          )}

          <div className="row">
            <div className="col-12">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="presidents" />
                </h3>
              </div>
            </div>

            <SimpleSlider oldBoss={oldBoss} bosses={bossList?.data?.data} />
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Boss;
